import {
  Avatar,
  Box,
  Button,
  Flex,
  Icon,
  Image,
  Skeleton,
  Stack,
  Text,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/core";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiEye, FiPlayCircle } from "react-icons/fi";
import { formatAMPM, formatDate, openExternalLink } from "../lib/utils/utils";
import styles from "./Card.module.css";
import jwtService from "../api/jwt.service";
import useAuth from "../context/AuthContext";
import { IconContext } from "react-icons/lib";
import { AiFillPlayCircle } from "react-icons/ai";
import { ReactTinyLink } from "react-tiny-link";

export const TargetCard = (props) => {
  return (
    <Box
      bg="white"
      shadow={["sm", "md"]}
      rounded="lg"
      w={["100%", "48%", "32%"]}
      mb={["4", "4", "0"]}
      h={["auto", "350px", "380px", "380px"]}
    >
      <Flex
        direction="column"
        justify="space-between"
        align={["center", "start"]}
        px={["4", "8"]}
        py={["12", "10"]}
      >
        <Box my="4">
          <Image src={props.icon} size={["40px", "48px"]} id="will-hide" />
        </Box>
        <Text
          fontSize={["16px", "xl"]}
          fontWeight="700"
          fontFamily="Familiar Pro"
          color="#0B132B"
          textAlign={["center", "start"]}
          lineHeight="normal"
          my="4"
          w={props.heading.includes("Renewable") && "100%"}
        >
          {props.heading}
        </Text>
        <Text
          textAlign={["center", "start"]}
          color="#0B132B"
          my="auto"
          // fontSize={["16px", "16px"]}
          lineHeight="tall"
        >
          {props.body}
        </Text>
      </Flex>
    </Box>
  );
};

export const OyeJobCard = (props) => {
  const {
    state: { isLowBandwidth },
  } = useAuth();
  return (
    <Box
      bg="white"
      rounded={["sm", "lg"]}
      w={["95vw", "32%"]}
      my={["2", "2"]}
      px={["0", "4"]}
      py={["4", "8"]}
    >
      <Stack isInline spacing="4">
        <Box ml={["8", "0"]} overflow="hidden">
          <Image
            src={props.icon}
            size="60px"
            rounded="full"
            objectFit="cover"
            display={isLowBandwidth ? "none" : "block"}
            id="will-hide"
            className="animated"
          />
        </Box>
        <Flex direction="column" flex={["center", "start"]}>
          <Text fontWeight="800" fontSize={["16px", "16px"]}>
            {props.title}
          </Text>
          <Text fontSize={["16px", "16px"]}>{props.position}</Text>
          <Text fontSize={["16px", "16px"]}>{props.companyName}</Text>
        </Flex>
      </Stack>
    </Box>
  );
};

export const JobCard = (props) => {
  const {
    state: { isLowBandwidth },
  } = useAuth();

  return (
    <Box
      bg="white"
      rounded={["sm", "lg"]}
      w={[props.width[0], props.width[1]]}
      mx={["auto", "0"]}
      my={["2", "4"]}
      px={["0", "6"]}
      py={["8", "10"]}
      shadow={props.shadow && "lg"}
      h={["auto", "270px"]}
      className="animated-small"
      _hover={{ bg: "#eeee" }}
    >
      <Stack isInline spacing="2">
        <Box ml={["8", "0"]} mr="2" w="80px" h="80px">
          {isLowBandwidth ? (
            <Box
              w="60px"
              h="60px"
              bg="#eee"
              d="flex"
              alignItems="center"
              justifyContent="center"
              rounded="full"
            >
              <Text color="#ccc" fontSize="10px" textAlign="center">
                Low Bandwidth
              </Text>
            </Box>
          ) : (
            <Image src={props.image} w="100%" h="100%" objectFit="contain" />
          )}
        </Box>
        <Flex direction="column" flex={["center", "start"]} ml="2">
          <Text
            fontWeight="800"
            fontSize={["16px", "18px"]}
            fontFamily="Familiar Pro"
          >
            {props.title}
          </Text>
          <Text fontSize={["16px", "18px"]}>{props.companyName}</Text>
          <Stack mt="4">
            <Text>
              <strong>Location:</strong> {props.location}
            </Text>
            <Text>
              <strong>Sector: </strong>
              {props.jobType}
            </Text>
            <Box
              bg={
                props.status === "pending"
                  ? "yellow.100"
                  : props.status === "accepted"
                  ? "green.100"
                  : props.status === "rejected" && "red.100"
              }
              rounded="full"
              alignSelf="start"
              px="4"
              my="2"
            >
              <Text fontSize={["16px", "16px"]}>{props.status}</Text>
            </Box>
          </Stack>
        </Flex>
      </Stack>
    </Box>
  );
};

export const EmployeeCard = (props) => {
  const {
    state: { isLowBandwidth },
  } = useAuth();
  return (
    <Stack align="center" justify="center" spacing="4">
      <Box
        w={props.width && [props.width[0], props.width[1]]}
        h="80px"
        mr="0px"
        rounded="full"
        alignSelf="center"
        mb={["2", "0"]}
        shadow="sm"
        bg="white"
      >
        {isLowBandwidth ? (
          <Box
            w={["80px", "120px"]}
            h={["80px", "120px"]}
            bg="#eee"
            d="flex"
            flexWrap="wrap"
            alignItems="center"
            justifyContent="center"
            rounded="full"
            my={["10", "2"]}
          >
            <Text color="#ccc" textAlign="center" fontSize={["10px", "14px"]}>
              {props.name || "Low Bandwidth"}
            </Text>
          </Box>
        ) : (
          <Image
            src={props.image}
            w="100%"
            h="100%"
            objectFit="contain"
            objectPosition="center"
            id="will-hide"
            rounded="full"
          ></Image>
        )}
        {!isLowBandwidth && props.name && (
          <Text w="100%" fontSize="14px" textAlign="center" mt="4">
            {props?.name.split(" ")?.[0] +
              " " +
              (props?.name.split(" ")?.[1] || "")}
          </Text>
        )}
      </Box>
    </Stack>

    // </Box>
    // </Box>
  );
};

export const SecondaryJobCard = (props) => {
  const {
    state: { isLowBandwidth },
  } = useAuth();

  return (
    <Box
      // w={["98vw", "auto"]}
      // h={["500px", "400px"]}
      bg="gray.700"
      my={["10", "10", "20"]}
      mx="auto"
      className={styles.SecondaryCard}
      // pb={["8", "0"]}
    >
      <Flex
        h="100%"
        flexDirection={[
          props.isReversed ? "column" : "column",
          props.isReversed ? "column" : "column",
          props.isReversed ? "row-reverse" : "row",
        ]}
        justify="center"
        align="center"
        bg="white"
        // shadow='md'
      >
        <Box
          w={["100%", "100%", "40%"]}
          h={["50%", "50%", "100%"]}
          overflow="hidden"
        >
          {isLowBandwidth ? (
            <Box
              w="100%"
              h={["200px", "200px", "100%"]}
              bg="#eee"
              d="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Text color="#ccc">Low Bandwidth Mode</Text>
            </Box>
          ) : (
            <Image
              src={props.image}
              objectFit="cover"
              size="100%"
              id="will-hide"
              className="animated"
            ></Image>
          )}
        </Box>
        <Flex
          w={["100%", "100%", "60%"]}
          bg="white"
          h="100%"
          direction="column"
          align="flex-start"
          className={styles.SecondaryCardContent}
        >
          <Text
            color="#0B132B"
            fontSize={["xl", "2xl", "3xl"]}
            fontWeight="900"
            fontFamily="Familiar Pro"
          >
            {props.title}
          </Text>
          <Text
            mt="2"
            lineHeight={["tall", "taller"]}
            mb={["2", "0"]}
            className={styles.TextLarge}
          >
            {props.description}
          </Text>
          <Flex
            justify="space-between"
            w="100%"
            align="center"
            mt={["4", "4"]}
            mb={["10px", "4"]}
          >
            {props.children}
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

export const TertiaryJobCard = (props) => {
  return (
    <Box w="90%" my={["4", "6", "20"]} className="animated-small">
      <Flex
        direction="column"
        p={["6", "10"]}
        bg={props.title === "Mentors" ? "#00A551" : "#00A551"}
        my={["2", "10"]}
        h={["auto", "auto", "380px"]}
        w="100%"
        justify="center"
      >
        <Text
          color="white"
          fontSize={["xl", "2xl", "3xl"]}
          fontWeight="900"
          fontFamily="Familiar Pro"
        >
          {props.title}
        </Text>
        <Text
          mt="2"
          lineHeight={["tall", "tall"]}
          color="white"
          flex="1"
          className={styles.TextLarge}
        >
          {props.description}
        </Text>
        <Flex justify="space-between" w="100%" align="center" mt={["4", "8"]}>
          <Flex justify={["center", "start"]} align="center" mx={["0", "0"]}>
            <Text
              color="white"
              mr={["2", "4"]}
              fontWeight="600"
              fontSize="16px"
            >
              Read More
            </Text>
            <Link to={props.title === "Mentors" ? "/mentors" : "/investors"}>
              <Button bg="#fff" _hover={{ bg: "#fff" }}>
                <Icon
                  name="arrow-forward"
                  color="#00A551"
                  size={["16px", "20px"]}
                />
              </Button>
            </Link>
          </Flex>
          <Link
            to={
              props.title === "Mentors"
                ? "/auth/register?role=mentor"
                : "/auth/register?role=investor"
            }
          >
            <Button
              rightIcon="arrow-forward"
              color="white"
              mr={["0", "4"]}
              variant="outline"
              fontWeight="800"
              px={["20px", "40px"]}
              _hover={{ color: "#000", background: "white" }}
            >
              Apply
            </Button>
          </Link>
        </Flex>
      </Flex>
    </Box>
  );
};

export const EventCard = (props) => {
  const {
    state: { isLowBandwidth },
  } = useAuth();
  const truncate = (str, maxLength) =>
    str.length > maxLength ? `${str.substring(0, maxLength)} ...` : str;
  return (
    <Box
      w={[props.width[0], props.width[1]]}
      mr={[props.marginRight[0], props.marginRight[1]]}
      ml={["auto", "0"]}
      mb={["4", "10"]}
      bg="white"
      shadow="sm"
    >
      <Flex direction="column" w="100%">
        <Box width="100%" h={["200px", "250px"]} d="flex" overflow="hidden">
          {isLowBandwidth ? (
            <Box
              w="100%"
              h="100%"
              bg="#eee"
              d="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Text color="#ccc">Low Bandwidth Mode</Text>
            </Box>
          ) : (
            <Image
              className="animated"
              src={props.imageSrc}
              objectFit="cover"
              width="100%"
              h="100%"
              id="will-hide"
              borderBottom="3px solid #77ed4e"
              fallbackSrc={
                "https://d15hjx36yaxuny.cloudfront.net/resources/image/cb8GJMrTHG5pbrv6n3L7Rpkjq8StrzEpqhy4B1Wu.png"
              }
            ></Image>
          )}
        </Box>
        <Flex
          justify="space-between"
          align="start"
          px="4"
          py="2"
          direction="column"
          flex="1"
          h="100%"
        >
          <Text
            flex="1"
            my="1"
            fontSize="18px"
            fontWeight="800"
            fontFamily="Familiar Pro"
          >
            {truncate(props.heading, 34)}
          </Text>

          {props.date && props.time && props.venue && (
            <>
              <Flex direction="row" align="center">
                <Text fontSize="14px" fontWeight="500" color="gray.500">
                  {formatDate(props.date)}
                </Text>

                <Text fontSize="14px" ml="2">
                  - {formatAMPM(props.time)}
                </Text>
              </Flex>
              <Text fontSize="14px">{props.venue && props.venue}</Text>
            </>
          )}
          {props.views && (
            <Flex align="center">
              <FiEye />
              <Text fontSize="14px" ml="2" mt="2px" mb="2px">
                {props.views} views
              </Text>
            </Flex>
          )}
        </Flex>
        <Box px="4" pb="6" h="100%">
          {props.children}
        </Box>
      </Flex>
    </Box>
  );
};

export const EventCardSmall = (props) => {
  const splitDate = () => {
    const date = props.date.split(" ");
    const month = date[0].slice(0, 3);
    const day = date[1].split(",")[0];

    return {
      month,
      day,
    };
  };

  return (
    <Flex align="center">
      {!props.alt && (
        <Box
          w={["110px", "90px"]}
          h={["110px", "90px"]}
          bg="#fff"
          borderTop="5px solid green"
          borderBottom="2px solid #eee"
          borderLeft="2px solid #eee"
          borderRight="2px solid #eee"
          p="6"
          d="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <Text fontWeight="500" fontSize="xl">
            {splitDate().month.toUpperCase()}
          </Text>
          <Text fontWeight="800" fontSize="4xl">
            {splitDate().day}
          </Text>
        </Box>
      )}
      <Stack ml={!props.alt && "4"} spacing="2">
        <Text
          fontWeight="700"
          fontSize={["16px", "18px"]}
          fontFamily="Familiar Pro"
          color={props.alt && "#00A551"}
          display={props.alt && "inline-block"}
          className={props.alt && "hvr-underline-from-left"}
        >
          {props.heading}
        </Text>
        <Text color="#837d85">
          {props.date} {formatAMPM(props.time)}
        </Text>
      </Stack>
    </Flex>
  );
};

export const ResourceCard = ({
  resource,
  imageSrc,
  width,
  fallbackImg,
  onOpen,
  setParams,
}) => {
  const {
    state: { isLowBandwidth },
  } = useAuth();
  const truncate = (str, maxLength) =>
    str.length > maxLength ? `${str.substring(0, maxLength)} ...` : str;

  const onOpenModal = () => {
    setParams();
    onOpen();
  };

  const splitDate = (date) => {
    const dateStr = date.split(",");
    const month = dateStr[0].split(" ")[0];
    const year = dateStr[1];

    return {
      month,
      year,
    };
  };

  const videoRef = React.createRef(null);
  const [isOpen, setIsOpen] = React.useState(false);

  const { onClose } = useDisclosure();

  const openVideoModal = () => setIsOpen(true);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        size="800px"
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Watch Video</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <video
              width="100%"
              height="100%"
              style={{
                objectFit: "contain",
              }}
              ref={videoRef}
              autoPlay
              controls
            >
              <source src={resource.url} type="video/mp4"></source>
            </video>
          </ModalBody>
        </ModalContent>
      </Modal>
      <Box
        w={[width[0], width[1]]}
        bg="white"
        mx={["auto", "2"]}
        mb={["8", "20"]}
        shadow="md"
        className={styles.ResourceCard}
      >
        <Flex direction="column" h="100%" w="100%">
          {isLowBandwidth ? (
            <Box
              width="100%"
              borderBottom="3px solid #77ed4e"
              h={["250px", "180px"]}
              bg="#eee"
              d="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Text color="#ccc">Low Bandwidth mode.</Text>
            </Box>
          ) : (
            <>
              <Box
                width="100%"
                h={["100%", "80%"]}
                overflow="hidden"
                borderBottom="3px solid #77ed4e"
                bg="#fff"
              >
                {(resource.type === "image" ||
                  resource.type === "docs" ||
                  resource.type === "link") && (
                  <Image
                    src={
                      resource.type === "docs"
                        ? resource.cover_image || imageSrc
                        : resource.type === "image"
                        ? resource.cover_image || resource.url
                        : resource.type === "link"
                        ? resource.cover_image ||
                          "https://d15hjx36yaxuny.cloudfront.net/resources/image/cb8GJMrTHG5pbrv6n3L7Rpkjq8StrzEpqhy4B1Wu.png"
                        : fallbackImg
                    }
                    objectFit={resource.type === "docs" ? "cover" : "contain"}
                    objectPosition={resource.type === "docs" ? "center" : "top"}
                    w="100%"
                    h={["250px", "200px"]}
                    mx="auto"
                    id="will-hide"
                    className="animated"
                    fallbackSrc={fallbackImg}
                  ></Image>
                )}
                {/* {resource.type === "link" && (
                  <ReactTinyLink
                    // cardSize='large'
                    showGraphic={true}
                    maxLine={2}
                    minLine={1}
                    url={"https://www.youtube.com/watch?v=MejbOFk7H6c"}
                  />
                )} */}
                {resource.type === "video" && (
                  <Box
                    position="relative"
                    w="100%"
                    h={["250px", "150px"]}
                    borderBottom="3px solid #77ed4e"
                  >
                    <video
                      width="100%"
                      height="100%"
                      className="animated"
                      style={{
                        objectFit: "contain",
                      }}
                      ref={videoRef}
                    >
                      <source src={resource.url} type="video/mp4"></source>
                    </video>
                    <Box
                      position="absolute"
                      top="50%"
                      left="50%"
                      transform="translate(-50%, -50%)"
                      cursor="pointer"
                      // display={
                      //   videoRef.current?.currentTime > 0 ? "none" : "block"
                      // }
                      onClick={() => openVideoModal()}
                    >
                      <IconContext.Provider
                        value={{ size: "62px", color: "#fff" }}
                      >
                        <AiFillPlayCircle />
                      </IconContext.Provider>
                    </Box>
                  </Box>
                )}
              </Box>
            </>
          )}

          {/* <FilePreviewerThumbnail file={{ url: resource.url }} /> */}

          <Box h="100%" w="100%" pt="2">
            <Text
              flex="1"
              width="100%"
              color="rgba(0, 0, 0, .7)"
              fontWeight="500"
              px="4"
            >
              {resource.description && truncate(resource.description, 30)}
            </Text>
            <Flex align="center" justify="space-between" px="4" py="0" w="100%">
              <Text
                flex="1"
                fontSize="14px"
                width="100%"
                fontWeight="600"
                color="#837d85"
              >
                Author: {resource.author ? resource.author : ""}
              </Text>
              <Text
                flex="1"
                fontWeight="500"
                color="#837d85"
                mr="0"
                textAlign="right"
                fontSize="14px"
              >
                {resource.date
                  ? `${splitDate(formatDate(resource.date)).month},${
                      splitDate(formatDate(resource.date)).year
                    }`
                  : ""}
              </Text>
            </Flex>
            <Flex align="center" mt="2">
              {resource.type === "link" ? (
                <Button
                  variant="outline"
                  alignSelf="start"
                  variantColor="green"
                  m="4"
                  onClick={() => openExternalLink(resource.url)}
                >
                  Visit Link
                </Button>
              ) : (
                <Button
                  rightIcon={resource.type === "video" ? "" : "arrow-down"}
                  variant="outline"
                  alignSelf="start"
                  variantColor="green"
                  m="4"
                >
                  <a
                    href={resource.url}
                    download
                    target="blank"
                    style={{ fontSize: "14px" }}
                  >
                    {resource.type === "video" ? "Play Video" : "Download"}
                  </a>
                </Button>
              )}

              {resource.description && resource.description.length > 25 ? (
                <Button
                  variant="link"
                  alignSelf="start"
                  variantColor="green"
                  alignSelf="center"
                  onClick={onOpenModal}
                  fontSize="14px"
                >
                  Read More
                </Button>
              ) : (
                ""
              )}
            </Flex>
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export const BusinessCard = (props) => {
  const {
    name,
    email,
    address,
    selectedIndex,
    onSelect,
    registration,
    applyHandler,
    createJobHandler,
    applicationType,
    actionType,
    id,
  } = props;

  const { pathname } = useLocation();

  return (
    <>
      <Box
        d="flex"
        shadow="sm"
        px={["2", "10"]}
        py={["2", "4"]}
        justifyContent="center"
        alignItems="center"
        justifyItems="center"
        border={selectedIndex === id ? "2px solid rgb(163, 250, 185)" : ""}
        my="2"
        // w='100%'
        // overflowX='auto'
      >
        <Avatar name={name} flexBasis="5%" rounded="full" />
        <Text
          fontSize={["14px", "16px"]}
          textAlign="center"
          flexBasis="15%"
          ml={["8", "0"]}
        >
          {registration}
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          textAlign="center"
          flexBasis={["100%", "30%"]}
          ml={["8", "0"]}
          w="100%"
        >
          {name}
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          textAlign="center"
          flexBasis="20%"
          ml={["8", "0"]}
          w="100%"
        >
          {email}
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          textAlign="center"
          flexBasis={["100%", "10%"]}
          ml={["8", "0"]}
          w="100%"
        >
          {address}
        </Text>
        <Stack
          flexBasis="20%"
          alignSelf="center"
          justifySelf="center"
          isInline
          textAlign="center"
          justify="center"
          ml={["8", "0"]}
        >
          <Link
            to={
              pathname.includes("/dashboard")
                ? `/dashboard/business/${id}`
                : `/business/${id}`
            }
          >
            <Button bg="green.200">View</Button>
          </Link>

          {(applicationType || actionType) && (
            <Button
              onClick={
                selectedIndex === id && applicationType
                  ? applyHandler
                  : selectedIndex === id && actionType
                  ? createJobHandler
                  : onSelect
              }
              bg={selectedIndex === id ? "green.400" : "gray.50"}
              _hover={
                selectedIndex === id
                  ? { backgroundColor: "green.400" }
                  : { backgroundColor: "gray.100" }
              }
              _focus="none"
            >
              {selectedIndex === id && applicationType
                ? "Apply"
                : selectedIndex === id && actionType
                ? "Add Job"
                : (applicationType || actionType) && "Select"}
            </Button>
          )}
        </Stack>
      </Box>
    </>
  );
};

export const BusinessCardHeading = () => {
  return (
    <>
      <Box
        d="flex"
        shadow="sm"
        px={["2", "10"]}
        py={["2", "2"]}
        justifyContent="space-between"
        alignItems="center"
        my="2"
        bg="green.100"
      >
        <Text
          fontSize={["14px", "16px"]}
          fontWeight="700"
          textAlign="center"
          flexBasis="5%"
        ></Text>
        <Text
          fontSize={["14px", "16px"]}
          fontWeight="700"
          textAlign="center"
          flexBasis="15%"
          ml={["8", "0"]}
        >
          Reg.No
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          fontWeight="700"
          textAlign="center"
          flexBasis="20%"
          ml={["8", "0"]}
        >
          Company Name
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          fontWeight="700"
          textAlign="center"
          flexBasis="25%"
          ml={["8", "0"]}
        >
          Email
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          fontWeight="700"
          textAlign="center"
          flexBasis="15%"
          ml={["8", "0"]}
        >
          Location
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          fontWeight="700"
          textAlign="center"
          flexBasis="20%"
          ml={["8", "0"]}
        >
          Actions
        </Text>
      </Box>
    </>
  );
};

export const ApplicationCardHeading = () => {
  return (
    <>
      <Box
        d="flex"
        shadow="sm"
        px={["2", "10"]}
        py={["2", "0"]}
        justifyContent="start"
        alignItems="center"
        my="2"
        bg="green.100"
      >
        <Text
          fontSize={["14px", "16px"]}
          fontWeight="700"
          textAlign="center"
          flexBasis="15%"
          ml={["8", "0"]}
        >
          Application Type
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          fontWeight="700"
          textAlign="center"
          flexBasis="20%"
          ml={["8", "0"]}
        >
          Applicant
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          fontWeight="700"
          textAlign="center"
          flexBasis="20%"
          ml={["8", "0"]}
        >
          Date Applied
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          fontWeight="700"
          textAlign="center"
          flexBasis="15%"
          ml={["8", "0"]}
        >
          Business Name
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          fontWeight="700"
          textAlign="center"
          flexBasis="10%"
          alignSelf="center"
          ml={["8", "0"]}
        >
          Status
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          fontWeight="700"
          textAlign="center"
          flexBasis="20%"
          ml={["8", "0"]}
        >
          Actions
        </Text>
      </Box>
    </>
  );
};

export const TestimonyCard = (props) => {
  return (
    <Box>
      <Flex
        w={["98%", "98%", "78%"]}
        mx="auto"
        h="auto"
        bg="#CDEDDC"
        shadow="lg"
        px={["4", "20"]}
        py="10"
        direction={["column", "column", "row"]}
      >
        <Avatar
          alignSelf="start"
          size="2xl"
          src={props.image}
          className="animated-small"
        />
        <Stack ml={["2", "2", "10"]}>
          <Text mt="2" fontSize="18px">
            <span>"</span>
            {props.quote} <span>"</span>
          </Text>
          <Stack mt="10">
            <Text color="#05a652" fontWeight="700" fontSize="xl">
              ~{props.name}
            </Text>
            <Text fontWeight="700" fontSize="xl">
              {props.support}
            </Text>
            <Text fontWeight="700" fontSize="16px">
              <i>{props.location}</i>
            </Text>
          </Stack>
        </Stack>
      </Flex>
    </Box>
  );
};
// export const ApplicationTable = ({ children }) => {
//   return (
//     <>
//       <ApplicationCardHeading />
//       {children}
//     </>
//   );
// };

export const ApplicationCard = ({ application, type }) => {
  return (
    <>
      <Box
        d="flex"
        shadow="sm"
        px={["2", "6"]}
        py={["2", "2"]}
        justifyContent="center"
        alignItems="center"
        justifyItems="center"
        my="2"
      >
        <Text
          fontSize={["14px", "16px"]}
          textAlign="center"
          flexBasis="20%"
          ml={["8", "0"]}
        >
          {type[0].toUpperCase() + type.slice(1)}
        </Text>

        <Text
          fontSize={["14px", "16px"]}
          textAlign="center"
          flexBasis={["100%", "15%"]}
          ml={["8", "0"]}
          w="100%"
        >
          {application.user &&
            application.user?.first_name + " " + application.user?.last_name}
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          textAlign="center"
          flexBasis="20%"
          ml={["8", "0"]}
          w="100%"
        >
          {formatDate(application.created_at)}
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          textAlign="center"
          flexBasis="15%"
          ml={["8", "2"]}
          alignSelf="center"
          mx="auto"
        >
          {type === "oye" && "N/A"}
          {application.business && application.business.name}
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          textAlign="center"
          flexBasis="10%"
          ml={["8", "2"]}
          alignSelf="center"
          mx="auto"
          color="yellow.500"
        >
          pending
        </Text>

        <Stack
          flexBasis="20%"
          alignSelf="center"
          justifySelf="center"
          isInline
          textAlign="center"
          justify="center"
          ml={["8", "0"]}
        >
          <Link
            to={{
              pathname: `/dashboard/application-forms`,
              state: {
                id: application.id,
                forms: application.details,
              },
            }}
          >
            <Button bg="green.200">View</Button>
          </Link>
        </Stack>
      </Box>
    </>
  );
};

export const JobApplicationCardHeading = () => {
  return (
    <>
      <Box
        d="flex"
        shadow="sm"
        px={["2", "10"]}
        py={["2", "0"]}
        justifyContent="start"
        alignItems="center"
        my="2"
        bg="green.100"
      >
        <Text
          fontSize={["14px", "16px"]}
          fontWeight="700"
          textAlign="center"
          flexBasis="15%"
          ml={["8", "0"]}
        >
          Job Title
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          fontWeight="700"
          textAlign="center"
          flexBasis="20%"
          ml={["8", "0"]}
        >
          Applicant
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          fontWeight="700"
          textAlign="center"
          flexBasis="20%"
          ml={["8", "0"]}
        >
          Date Apllied
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          fontWeight="700"
          textAlign="center"
          flexBasis="15%"
          ml={["8", "0"]}
        >
          Posted By
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          fontWeight="700"
          textAlign="center"
          flexBasis="10%"
          alignSelf="center"
          ml={["8", "0"]}
        >
          Status
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          fontWeight="700"
          textAlign="center"
          flexBasis="20%"
          ml={["8", "0"]}
        >
          Actions
        </Text>
      </Box>
    </>
  );
};

export const JobApplicationCard = ({ application }) => {
  return (
    <>
      <Box
        d="flex"
        shadow="sm"
        px={["2", "6"]}
        py={["2", "2"]}
        justifyContent="center"
        alignItems="center"
        justifyItems="center"
        my="2"
      >
        <Text
          fontSize={["14px", "16px"]}
          textAlign="center"
          flexBasis="20%"
          ml={["8", "0"]}
        >
          {application.job?.title}
        </Text>

        <Text
          fontSize={["14px", "16px"]}
          textAlign="center"
          flexBasis={["100%", "15%"]}
          ml={["8", "0"]}
          w="100%"
        >
          {application.user &&
            application.user?.first_name + " " + application.user?.last_name}
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          textAlign="center"
          flexBasis="20%"
          ml={["8", "0"]}
          w="100%"
        >
          {formatDate(application.created_at)}
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          textAlign="center"
          flexBasis="15%"
          ml={["8", "2"]}
          alignSelf="center"
          mx="auto"
        >
          {application.job?.business && application.job?.business.name}
        </Text>
        <Text
          fontSize={["14px", "16px"]}
          textAlign="center"
          flexBasis="10%"
          ml={["8", "2"]}
          alignSelf="center"
          mx="auto"
          color="yellow.500"
        >
          {application.status}
        </Text>

        <Stack
          flexBasis="20%"
          alignSelf="center"
          justifySelf="center"
          isInline
          textAlign="center"
          justify="center"
          ml={["8", "0"]}
        >
          <Link
            to={{
              pathname: `/dashboard/jobs/${application.job.id}`,
            }}
          >
            <Button bg="green.200">View</Button>
          </Link>
        </Stack>
      </Box>
    </>
  );
};
